import { render, staticRenderFns } from "./PageNotFoundComponent.vue?vue&type=template&id=7db8f239&"
import script from "./PageNotFoundComponent.vue?vue&type=script&lang=ts&"
export * from "./PageNotFoundComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports